<template lang="pug">
div
  h2 Notificaties
  v-progress-linear(indeterminate, v-if='loading')

  template(v-else)
    p.mb-4(v-if='notifications.length > 0') Klik op een notificatie om direct naar de aanvraag te gaan
    p.mb-4(v-else) Er zijn nog geen notificaties
    notification(v-for='n in notifications', :data='n', :key='n.id')
</template>

<script>
export default {
  components: {
    Notification: require('./Notification').default
  },

  data () {
    return {
      notifications: [],
      loading: false
    }
  },

  async created () {
    this.loading = true

    this.notifications = await this.$store.dispatch('graphqlQuery', {
      name: 'getNotifications',
      variables: {
        orgId: this.$store.state.organization.currentOrgId
      },
      ignoreCache: true
    })

    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
</style>
